export default __webpack_public_path__ + "static/GGRA-logo-transparent-3477550542692c85e4ea986bd86a0967.png";